<template>
  <div id="wt-h-100">
    <!-- LOADING -->
    <div id="wt-loading" :class="{'wt-loading-show': showLoading}">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <!-- BACK MENU NAVIGATION -->
    <ul class="new-task-nav">
      <li>
        <b-button variant="primary" @click="forceCardListUpdate">
          <i class="fas fa-arrow-left back-icon mr-2"></i>
          <strong>Back</strong>
        </b-button>
      </li>
    </ul>

    <!-- MODAL CONFIRMATION -->
    <b-modal centered cancel-disabled ok-disable id="confirmation" v-model="modalShow">
      <template v-slot:modal-header="{}"></template>

      <template v-slot:default="{}">
        <img src="@/assets/default/new.png" alt="Confirmation Logo" />
        <p class="confirm-title">Novo Processo</p>
        <p class="confirm-description">Deseja abrir um novo processo de</p>
        <p class="confirm-description">
          <strong>{{task_selected.bpm_process_data.process_label}}</strong>?
        </p>
      </template>

      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button pill id="ok" size="sm" @click="selectBpmTaskCard(task_selected)">OK</b-button>
        <b-button pill id="cancel" size="sm" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
    <!-- FINISH - MODAL CONFIRMATION -->

    <b-form class="text-uppercase wt-new-task-list p-4" id="new-task-list">
      <!-- TASK LIST -->
      <div class="box-new-task-list" v-if="!process_selected">
        <div class="new-task-header">
          <p id="task-title">Abrir Nova Task</p>
          <p class="bpm-new-task-search">
            <i class="fas fa-search mx-2"></i>
            <input type="text" name="search" id placeholder="search..." v-model="search" />
          </p>
        </div>
        <div class="new-task-list">
          <!--<ul class="m-0">-->
          <ul class="m-0">
            <!-- search?filteredRoles:objItems -->
            <li v-for="task in search?filteredRoles:objItems" :key="task.bpm_process_id">
              <b-button id="btn" class="w-100 text-left" @click="openModal(task)">
                <span>
                  <i class="fas fa-caret-right mx-2"></i>
                  <strong class="wts-strong">{{task.bpm_process_data.process_label}}</strong>
                </span>
                <span>1.0.0</span>
              </b-button>
            </li>
          </ul>
          <!--</ul>-->
        </div>
      </div>
      <!-- finish - TASK LIST -->

      <!-- TASK EDIT -->
      <div v-if="process_selected">
        <template>
          <BpmHomeTaskEdit
            :objItems="columns"
            :taskList="tasklist"
            @forceCardListUpdate="forceCardListUpdate()"
          ></BpmHomeTaskEdit>
        </template>
      </div>
      <!-- finish - TASK EDIT -->
    </b-form>
  </div>
</template>


<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";
import json from "./bpm_find.json";
import BpmHomeTaskEdit from "./BpmHomeTaskEdit";

export default {
  name: "BpmHomeNewTask",
  components: { BpmHomeTaskEdit },
  computed: {
    filteredRoles() {
      return this.objItems.filter(post => {
        return post.bpm_process_data.process_label
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },
    showLoading() {
      return this.$store.state.loading.showLoading;
    }
  },
  props: {
    createNew: Boolean
  },
  data: function() {
    return {
      urlServices: "chameleon-ds/api/internal/bpm-process",
      primary_key: "bpm_process_id",
      objItems: [],
      search: "",
      json: json,

      modalShow: false,
      process_selected: false,

      objTaskCard: {},
      columns: {},
      tasklist: {},
      task_selected: {}
    };
  },
  methods: {
    list() {
      this.$store.commit("setShowLoading", true);
      this.objItems = [];
      axios
        .post(`${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all`)
        .then(res => {
          if (res.data[0][`${this.primary_key}`] != null)
            this.objItems = res.data;
          this.$store.commit("setShowLoading", false);
        });
    },
    forceCardListUpdate() {
      this.$emit("forceCardListUpdate", true);
    },
    openModal(task) {
      this.task_selected = task;
      this.modalShow = true;
    },
    async selectBpmTaskCard(task) {
      this.$store.commit("setShowLoading", true);
      this.process_selected = true;
      this.modalShow = false;

      /**
       * Posteriormente o id da versão será recebido no objeto task
       */
      console.log("task", task);
      let vID = {};
      vID.bpm_process_version_id = "FF6D31FFC654415AB08027600E860A5E";

      // Insert
      axios["put"](
        `${baseApiUrl}:${baseApiPort}/chameleon-ds/api/internal/bpm-process-runner/insert`,
        vID
      ).then(res => {
        if (res.data[0]["bpm_process_runner_id"] != null)
          this.objItem = res.data[0];

        let objTasks = this.objItem.bpm_process_runner_data.tasks;
        for (var task in objTasks) {
          if (objTasks[task].task_id_predecessors == null) {
            this.objTaskCard = {
              // Obj
              bpm_process_runner_id: this.objItem.bpm_process_runner_id,
              //Data
              process_label: this.objItem.bpm_process_runner_data.process_label,
              bpm_process_id: this.objItem.bpm_process_runner_data
                .bpm_process_id,
              bpm_process_version_id: this.objItem.bpm_process_runner_data
                .bpm_process_version_id,
              // Current (task foreach)
              inputs: objTasks[task].columns,
              task_label: objTasks[task].task_label,
              task_name: objTasks[task].task_name,
              bpm_task_id: objTasks[task].bpm_task_id
            };
          }
        }

        this.$nextTick(() => {
          this.columns = this.objTaskCard;
          this.tasklist = null;
        });
        this.$store.commit("setShowLoading", false);
      });
    }
  },
  mounted() {
    this.list();
  },
  watch: {
    createNew() {
      if (this.createNew == true) {
        this.list();
      }
    }
  }
};
</script>